import '../Profile.css'
import { Box } from "@mui/material"
import Message from "components/blocks/message/Message";
import CircularIndeterminate from "components/blocks/progressBar/progressBar";
import ButtonLarge1 from "components/elements/ButtonLarge1";
import ContentNormal from "components/elements/ContentNormal";
import Headline5 from "components/elements/Headline5";
import { AppContext } from "contexts/AppContext";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { callAPI } from "utils/API";

const InboxPage = () => {
    const { styleGuide } = useContext(AppContext)
    const [loading, setLoading] = useState(true)
    const [messages, setMessages] = useState([])
    const [allMessages, setAllMessages] = useState([])

    const fetchMessages = async () => {
        const userMessagesLines = await callAPI(`/user/inbox`);
        if (!userMessagesLines || !userMessagesLines.length){
            setMessages([])
            setAllMessages([])
            setLoading(false)
        }
        
        const userMessages = userMessagesLines.map(messageLine => ({
            date: moment(messageLine.timeInsert).format("DD.MM.YYYY"),
            communicationChannel: messageLine.communicationChannel,
            messageRecipient: messageLine.communicationRecipient,
            messageSender: messageLine.communicationSender,
            messageSubject: messageLine.communicationSubject,
            messagePlainText: messageLine.communicationMessagePlainText,
        }));

        setLoading(false)
        setAllMessages(userMessages);
        setMessages(userMessages.slice(0, 5));
    };

    useEffect(() => {
        fetchMessages();
    }, []);

    return (
        <Box flex={1} display={'flex'} flexDirection={'column'} gap={2} marginBottom={10}>
            {loading
                ?
                <Box display={'flex'} flex={1} justifyContent={'center'} marginTop={2}>
                    <CircularIndeterminate />
                </Box>
                : !messages.length
                    ?
                    <Box
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "1rem",
                            border: `1px solid ${styleGuide.color4}`,
                            borderRadius: "14px",
                            padding: 40,
                        }}
                    >
                        <Headline5
                            translationKey="_PROFILE_PAGE_NO_MESSAGES_CAPTION_"
                            fallbackText="Du har ingen beskeder endnu"
                        />
                        <ContentNormal
                            translationKey="_PROFILE_PAGE_NO_MESSAGES_TEXT_"
                            fallbackText="Når du modtager en besked, vil du se den her. "
                        />
                    </Box>
                    :
                    <Box display={'flex'} flexDirection={'column'} gap={4}>
                        {messages.map((message, idx) => (
                            <Message key={idx} message={message} />
                        ))}
                        {!!messages &&
                            !!messages.length &&
                            messages.length != allMessages.length &&
                            <ButtonLarge1
                                showIcon={false}
                                translationKey="_MESSAGES_SEE_ALL_"
                                fallbackText="Se alle beskeder"
                                style={{ maxWidth: 150, alignSelf: "center" }}
                                onClick={() => setMessages(allMessages)}
                            />
                        }
                    </Box>
            }
        </Box>
    );
}

export default InboxPage